
import moment, { DurationInputArg2, Moment as IMoment } from 'moment';


const Now = (format: string = 'YYYY-MM-DD') => {
    return moment().format(format);
}


const Format = (date: string | Date | IMoment | undefined, format: string = 'DD/MM/YYYY') => {
    date = moment(date);
    if (!date.isValid()) {
        return undefined;
    }

    return date.format(format);
}


const Diff = (date1: string | Date | IMoment, date2: string | Date | IMoment) => {
    try {
        date1 = moment(date1);
        date2 = moment(date2);
        return date1.diff(date2, 'days');
    } catch (ex) {
        console.warn(`It was not possible to convert dates in the "Diff" method of DateTimeHelper`)
        return 9999;
    }
}


const Equals = (date1: string | Date | IMoment, date2: string | Date | IMoment) => {
    try {
        date1 = moment(date1);
        date2 = moment(date2);
        return date1.isSame(date2, 'days') && date1.isSame(date2, 'months') && date1.isSame(date2, 'years');
    } catch (ex) {
        console.warn(`It was not possible to convert dates in the "Equals" method of DateTimeHelper`);
        return 9999;
    }
}


const ToDate = (date: string | IMoment | undefined) => {
    date = moment(date);
    if (!date.isValid()) {
        date = moment();
    }

    return date.toDate();
}


const ToElapsedTime  = (time: number) => {
    const hours = Math.floor(time / 3600).toString().padStart(2, '0');
    const minutes = Math.floor(time % 3600 / 60).toString().padStart(2, '0');
    const seconds = Math.floor(time % 60).toString().padStart(2, '0');
    
    return `${hours}:${minutes}:${seconds}`;
}


const IsValid = (date: string | IMoment | undefined, format: string = 'DD/MM/YYYY') => {
    date = moment(date, format);
    return date.isValid();
}


const Add = (date: string | IMoment, time: number, period: DurationInputArg2, format: string = 'DD/MM/YYYY') => {
    date = moment(date).add(time, period);
    return date.format(format);
}


const Remove = (date: string | IMoment, time: number, period: DurationInputArg2, format: string = 'DD/MM/YYYY') => {
    date = moment(date).add(time * -1, period);
    return date.format(format);
}


const DateTimeHelper = {
    Now,
    Format,
    Diff,
    Equals,
    ToDate,
    ToElapsedTime,
    IsValid,
    Add,
    Remove
};

export default DateTimeHelper;